<template>
  <svg
    version="1.1"
    id="레이어_5"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 75.6 74.5"
    style="enable-background:new 0 0 75.6 74.5;"
    xml:space="preserve"
  >
    <path
      class="st0"
      d="M75.6,36.8l-2.1-12c-0.2-0.9-1-1.6-1.9-1.6L66.3,23c-0.6-1.1-1.2-2.2-1.9-3.3l2.5-4.6c0.5-0.8,0.3-1.9-0.5-2.5
	l-9.3-7.8c-0.7-0.6-1.8-0.6-2.5,0l-4,3.2c-1.2-0.5-2.4-0.9-3.6-1.3l-1-5.1c-0.2-1-1-1.6-2-1.6H31.8c-1,0-1.8,0.7-2,1.6l-1.1,5.1
	C27.5,7.1,26.2,7.5,25,8l-4-3.2c-0.7-0.6-1.8-0.6-2.5,0l-9.3,7.8c-0.7,0.6-0.9,1.6-0.5,2.5l2.5,4.6c-0.7,1.1-1.3,2.1-1.9,3.3L4,23.2
	c-0.9,0-1.7,0.7-1.9,1.6L0,36.8c-0.2,0.9,0.3,1.9,1.2,2.2l4.9,1.9c0.1,1.3,0.4,2.5,0.7,3.7l-3.9,3.5c-0.7,0.6-0.9,1.7-0.4,2.5
	l6.1,10.5c0.4,0.6,1,1,1.7,1c0.2,0,0.4,0,0.6-0.1l4.9-1.6c0.9,0.9,1.9,1.7,3,2.5L18,68.1c-0.1,0.9,0.4,1.8,1.3,2.2l11.4,4.1
	c0.2,0.1,0.4,0.1,0.7,0.1c0.7,0,1.4-0.4,1.8-1l2.7-4.4c0.6,0,1.3,0,1.9,0c0.6,0,1.3,0,1.9-0.1l2.7,4.4c0.3,0.6,1,1,1.7,1
	c0.2,0,0.4,0,0.6-0.1l11.5-4.1c0.9-0.3,1.4-1.3,1.3-2.2l-0.8-5.2c1-0.7,2-1.5,2.9-2.4l5,1.6c0.2,0.1,0.4,0.1,0.6,0.1
	c0.7,0,1.4-0.4,1.7-1L73,50.6c0.5-0.8,0.3-1.9-0.4-2.5l-3.9-3.4c0.3-1.3,0.5-2.5,0.7-3.8l4.8-1.9C75.2,38.7,75.7,37.7,75.6,36.8z
	 M37.8,53C29.1,53,22,46,22,37.3s7.1-15.8,15.8-15.8s15.8,7.1,15.8,15.8S46.5,53,37.8,53z"
    />
  </svg>
</template>

<script>
export default {
  name: 'ConfigFillIcon',
};
</script>

<style scoped>
.st0 {
  fill: #3e0ba5;
}
</style>
